module.exports = __webpack_public_path__ + "static/media/aninditapaul.9285f3da.png";